import React, { useEffect } from 'react'
import CouponBox from '../../../CouponBox'
import CouponConfigurableLabel from '../../../CouponConfigurableLabel'
import "./couponTimings.css";
import { Button } from '@mui/material';
import { AddCircleOutlineOutlined } from '@material-ui/icons';
import { addCouponTimingSlab } from '../../../../../../stateManagement/actions/manageCouponActions';
import { getEmptyTimingSlab, isEmptySlabPresentInCouponTimigs } from '../RecurrenceService';
import { useSelector } from 'react-redux';
import { labelMappings } from '../../../../utils/utils';
import { useCouponAlert } from '../../../../context/CouponAlert';
import { CouponTimingSlab } from '../../../../types';
import CouponTimingSingleSlab from './CouponTimingSingleSlab';



function CouponTimings() {
    const { couponTimings } = useSelector((state: any) => state?.manageCoupons?.data?.recurrence);
    const { showAlert } = useCouponAlert();

    const handleAddMoreClick = () => {
        const isEmptySlabPresent = isEmptySlabPresentInCouponTimigs(couponTimings);

        if (isEmptySlabPresent) {
            showAlert(labelMappings["coupon-timings-empty-template-exist"], 'warning')
            return;
        }

        addCouponTimingSlab(getEmptyTimingSlab());
    }

    useEffect(() => {
        if (couponTimings.length == 0) {
            addCouponTimingSlab(getEmptyTimingSlab());
        }
    }, [couponTimings])

    return (

        <CouponBox collapsible={false} showBorder={true} header={<CouponConfigurableLabel text='COUPON_TIMING' style={{ color: "inherit" }} />} >
            <div className='coupon-timings-wrapper'>
                <div className='coupon-timings-header-wrapper'>
                    <Button className='coupon-timings-addmore-btn' onClick={handleAddMoreClick} size='small' startIcon={<AddCircleOutlineOutlined />}>Add More</Button>
                </div>

                <div className="coupon-timings-wrapper-content">
                    {
                        couponTimings.map((slab: CouponTimingSlab) => {
                            return <CouponTimingSingleSlab slab={slab} key={slab.id}/>
                        })
                    }
                </div>
            </div>
        </CouponBox>
    )
}

export default CouponTimings